export const modalDialogData = {
    accountingPeriodConfirmClose: {
        id: 'accountingPeriodConfirmClose',
        header: 'accountingPeriod.confirm.close.title',
        body: ['accountingPeriod.confirm.close.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'close', type: 'primary', action: 'close', actionType: 'post', text: 'accountingPeriod.confirm.close.accept' }
        ]
    },
    accountingPeriodConfirmDelete: {
        id: 'accountingPeriodConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['accountingPeriod.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    accountingPeriodConfirmReopen: {
        id: 'accountingPeriodConfirmReopen',
        header: 'accountingPeriod.confirm.reopen.title',
        body: ['accountingPeriod.confirm.reopen.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'reopen', type: 'primary', action: 'reopen', actionType: 'post', text: 'accountingPeriod.confirm.reopen.accept' }
        ]
    },
    assetConfirmDelete: {
        id: 'assetConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.asset.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    // -- Non-standard modals (custom headers / actions / forms) ---------------
    bomVersionConfirmActivate: {
        id: 'bomVersionConfirmActivate',
        header: 'bomVersion.confirm.activate.title',
        body: ['bomVersion.confirm.activate.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'activate', type: 'primary', action: 'activate', text: 'bomVersion.confirm.activate.accept' }
        ]
    },
    bomVersionConfirmDelete: {
        id: 'bomVersionConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['bomVersion.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    bomVersionConfirmObsolete: {
        id: 'bomVersionConfirmObsolete',
        header: 'bomVersion.confirm.obsolete.title',
        body: ['bomVersion.confirm.obsolete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'obsolete', type: 'primary', action: 'obsolete', text: 'bomVersion.confirm.obsolete.accept' }
        ]
    },
    campaignConfirmDelete: {
        id: 'campaignConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['campaign.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    // -- Book / pre-book modals ----------------------------------------------
    confirmBook: {
        id: 'confirmBook',
        header: 'all.confirm.book.title',
        body: ['all.confirm.book.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'book', type: 'primary', action: 'book', text: 'all.confirm.book.accept' }
        ]
    },
    confirmClose: {
        id: 'confirmClose',
        header: 'all.confirm.close.title',
        body: ['all.confirm.close.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'close', type: 'primary', action: 'close', text: 'all.confirm.close.accept' }
        ]
    },
    confirmDelete: {
        id: 'confirmDelete',
        header: 'all.confirm.delete.title',
        body: ['all.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    confirmInitializeLedger: {
        id: 'confirmInitializeLedger',
        header: 'inventory.ledger.initialize.confirm.title',
        body: ['inventory.ledger.initialize.confirm.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'confirm', type: 'primary', action: 'confirm', text: 'inventory.ledger.initialize.confirm.accept' }
        ]
    },
    contactConfirmDelete: {
        id: 'contactConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['contact.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    contactPersonConfirmDelete: {
        id: 'contactPersonConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['contactPerson.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    contactUpdate: {
        id: 'contactUpdate',
        header: 'contact.list.bulk.update.modal.title',
        form: {
            section: {
                id: 'contactUpdateAttributesForm',
                meta: {
                    type: 'form',
                    width: '512px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'chooseWhatToUpdate',
                        label: 'contact.list.bulk.update.info.label',
                        text: 'contact.list.bulk.update.info.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'hconnect',
                        id: 'customerGroup',
                        displayField: 'customerGroup',
                        parentId: 'parentId',
                        label: 'contact.form.attributes.customerGroup',
                        placeholder: 'contact.form.attributes.customerGroup.placeholder',
                        modalTitle: "contact.form.attributes.customerGroup.modal.title",
                        entity: 'customerGroup',
                        parentField: { field: 'type', value: 'normal' },
                        valueMap: {
                            'customerGroup': 'id',
                        },
                        options: { withHeaders: true },
                        required: true,
                        defaultType: 'select',
                        linkedFields: ['customerGroup']
                    },
                    {
                        type: "currency",
                        id: 'currency',
                        displayField: 'currency',
                        parameter: "date",
                        label: 'contact.form.attributes.currency',
                        placeholder: 'contact.form.attributes.currency.placeholder',
                        modalTitle: "contact.form.attributes.currency.modal.title",
                        entity: 'currency',
                        valueMap: {
                            'currency': 'id',
                            'currencyName': 'name',
                        },
                        options: { withHeaders: false, displayId: true, autoSelectFirst: false },
                        required: true,
                        defaultType: 'currency',
                        autoComplete: 'price-code-currency'
                    },
                    {
                        type: "select",
                        id: "language",
                        displayField: "languageName",
                        label: "contact.form.attributes.language",
                        placeholder: "contact.form.attributes.language.placeholder",
                        modalTitle: "contact.form.attributes.language.modal.title",
                        entity: "language",
                        valueMap: {
                            language: "id",
                            languageName: "name",
                        },
                        options: { withHeaders: false, autoSelectFirst: false },
                        required: true,
                        defaultType: "none"
                    },
                    {
                        type: 'connect',
                        id: 'priceListId',
                        displayField: 'priceListId',
                        label: 'contact.form.priceList',
                        placeholder: 'contact.form.priceList.placeholder',
                        modalTitle: "contact.form.priceList.modal.title",
                        entity: 'priceList',
                        valueMap: {
                            'priceListId': 'id',
                            'priceListName': 'idName'
                        },
                        options: { withHeaders: true },
                        required: true,
                        defaultType: 'select',
                        linkedFields: ['currency']
                    },
                ],
                buttons: [
                ],
            },
        },
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'update',
                type: 'primary',
                action: 'update',
                text: 'all.confirm.update.accept'
            }
        ]
    },
    creditNoteConfirmRepost: {
        id: 'creditNoteConfirmRepost',
        header: 'ledger.repost.title',
        body: ['ledger.repost.confirm'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'repost', type: 'primary', action: 'repost', actionType: 'post', text: 'ledger.repost.accept' }
        ]
    },
    creditNoteConfirmSave: {
        id: 'creditNoteConfirmSave',
        header: 'all.confirm.save.title',
        body: ['document.confirm.save.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'save',
                type: 'primary',
                action: 'save',
                text: 'all.confirm.save.accept'
            }
        ]
    },
    // -- Delete modals -------------------------------------------------------
    documentConfirmDelete: {
        id: 'documentConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['documents.document.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    employeeConfirmDeactivate: {
        id: 'employeeConfirmDeactivate',
        header: 'employee.confirm.deactivate.title',
        body: ['employee.confirm.deactivate.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'deactivate', type: 'primary', action: 'deactivate', text: 'employee.confirm.deactivate.accept' }
        ]
    },
    employeeConfirmDelete: {
        id: 'employeeConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['employee.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    expenseConfirmBook: {
        id: 'expenseConfirmBook',
        header: 'all.confirm.book.title',
        body: ['purchases.expense.confirm.book.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'book', type: 'primary', action: 'book', text: 'all.confirm.book.accept' }
        ]
    },
    expenseConfirmDelete: {
        id: 'expenseConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['purchases.expense.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    folderConfirmDelete: {
        id: 'folderConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['documents.folder.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    glAccountConfirmDelete: {
        id: 'glAccountConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['glAccount.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    // Purchases › Inbox (38.04): the entry and, unless something else holds
    // it, the uploaded file with its reading — for good.
    inboxDocumentConfirmDelete: {
        id: 'inboxDocumentConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['purchases.inbox.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    interactionConfirmDelete: {
        id: 'interactionConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['interaction.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    invoiceConfirmBook: {
        id: 'invoiceConfirmBook',
        header: 'all.confirm.book.title',
        body: ['invoice.confirm.book.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'book', type: 'primary', action: 'book', text: 'all.confirm.book.accept' }
        ]
    },
    invoiceConfirmCredit: {
        id: 'invoiceConfirmCredit',
        header: 'all.confirm.credit.title',
        body: ['invoice.confirm.credit.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'credit',
                type: 'primary',
                action: 'credit',
                actionType: 'goTo',
                text: 'all.confirm.credit.accept',
                target: '/sales/creditNote/newFromInvoice/:id'
            }
        ]
    },
    invoiceConfirmDelete: {
        id: 'invoiceConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['invoice.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    invoiceConfirmRepost: {
        id: 'invoiceConfirmRepost',
        header: 'ledger.repost.title',
        body: ['ledger.repost.confirm'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'repost', type: 'primary', action: 'repost', actionType: 'post', text: 'ledger.repost.accept' }
        ]
    },
    invoicePreBook: {
        id: 'invoicePreBook',
        header: 'all.confirm.book.title',
        body: ['success.booking.ready.to.go'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'book', type: 'primary', action: 'book', text: 'all.confirm.book.accept' }
        ]
    },
    invoiceSendDialog: {
        id: 'invoiceSendDialog',
        header: 'invoice.send.modal.title',
        msg: {
            localLang: "da-DK",
            invoiceTitle: "Invoice No: ",
            companyName: "Code Setters ApS",
        },
        body: [],
        form: {
            section: {
                id: 'invoiceMessage',
                meta: {
                    type: 'form',
                    width: '512px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'to',
                        label: 'invoice.send.modal.to',
                        placeholder: 'invoice.send.modal.to.placeholder',
                        required: true,
                        defaultType: 'merge',
                        defaultValue: 'invoice.send.modal.messageTo'
                    },
                    {
                        type: 'text',
                        id: 'subject',
                        label: 'invoice.send.modal.subject',
                        placeholder: 'invoice.send.modal.subject.placeholder',
                        required: true,
                        defaultType: 'merge',
                        defaultValue: 'invoice.send.modal.messageTitle'
                    },
                    {
                        type: 'textarea',
                        id: 'message',
                        label: 'invoice.send.modal.description',
                        placeholder: 'invoice.send.modal.description.placeholder',
                        required: true,
                        defaultType: 'merge',
                        defaultValue: 'invoice.send.modal.message',
                        rows: 4
                    }
                ],
                buttons: [
                ],
                displaySection: {
                    emptyField: 'subject',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'subject',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'message',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        },
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'send', type: 'primary', action: 'send', text: 'all.confirm.send.accept' }
        ]
    },
    journalConfirmDelete: {
        id: 'journalConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['journal.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    journalConfirmPost: {
        id: 'journalConfirmPost',
        header: 'all.confirm.book.title',
        body: ['journal.confirm.post.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'post', type: 'primary', action: 'post', text: 'journal.confirm.post.accept' }
        ]
    },
    journalConfirmReverse: {
        id: 'journalConfirmReverse',
        header: 'journal.confirm.reverse.title',
        body: ['journal.confirm.reverse.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'reverse', type: 'primary', action: 'reverse', text: 'journal.confirm.reverse.accept' }
        ]
    },
    langSwitch: {
        id: 'langSwitch',
        header: 'langSwitch.title',
        body: ['langSwitch.body.01'],
        footer: [
            {
                id: 'dismiss',
                type: 'danger',
                action: 'dismiss',
                text: 'langSwitch.button.close'
            }
        ]
    },
    // Studio (30.03.08)
    modelFieldConfirmDelete: {
        id: 'modelFieldConfirmDelete',
        header: 'studio.confirm.field.hide.title',
        body: ['studio.confirm.field.hide.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'studio.confirm.field.hide.accept' }
        ]
    },
    modelOverlayConfirmDelete: {
        id: 'modelOverlayConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['studio.confirm.overlay.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    modelStatusConfirmDeploy: {
        id: 'modelStatusConfirmDeploy',
        header: 'studio.confirm.deploy.title',
        body: ['studio.confirm.deploy.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'deploy', type: 'primary', action: 'deploy', text: 'studio.confirm.deploy.accept' }
        ]
    },
    modelStatusConfirmDiscard: {
        id: 'modelStatusConfirmDiscard',
        header: 'studio.confirm.discard.title',
        body: ['studio.confirm.discard.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'discard', type: 'primary', action: 'discard', text: 'studio.confirm.discard.accept' }
        ]
    },
    modelStatusConfirmPreview: {
        id: 'modelStatusConfirmPreview',
        header: 'studio.confirm.preview.title',
        body: ['studio.confirm.preview.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'preview', type: 'primary', action: 'preview', text: 'studio.confirm.preview.accept' }
        ]
    },
    modelStatusConfirmReset: {
        id: 'modelStatusConfirmReset',
        header: 'studio.confirm.reset.title',
        body: ['studio.confirm.reset.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'reset', type: 'primary', action: 'reset', text: 'studio.confirm.reset.accept' }
        ]
    },
    modelVersionConfirmRollback: {
        id: 'modelVersionConfirmRollback',
        header: 'studio.confirm.rollback.title',
        body: ['studio.confirm.rollback.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'rollback', type: 'primary', action: 'rollback', text: 'studio.confirm.rollback.accept' }
        ]
    },
    organizationConfirmDelete: {
        id: 'organizationConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['organization.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    orgSwitch: {
        id: 'orgSwitch',
        header: 'orgSwitch.title',
        body: ['orgSwitch.body.01', 'orgSwitch.body.02'],
        footer: [
            {
                id: 'dismiss',
                type: 'danger',
                action: 'dismiss',
                text: 'orgSwitch.button.close'
            }
        ]
    },
    postingRuleConfirmDelete: {
        id: 'postingRuleConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['postingRule.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    preBook: {
        id: 'preBook',
        header: 'all.confirm.book.title',
        body: ['success.booking.ready.to.go'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'book', type: 'primary', action: 'book', text: 'all.confirm.book.accept' }
        ]
    },
    priceListUpdateItems: {
        id: 'priceListUpdateItems',
        header: 'priceList.confirm.updateItems.title',
        body: ['priceList.confirm.updateItems.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'updateItems',
                type: 'primary',
                action: 'updateItems',
                text: 'priceList.confirm.updateItems.accept'
            }
        ]
    },
    productConfirmDelete: {
        id: 'productConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['product.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    productFamilyConfirmDelete: {
        id: 'productFamilyConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['productFamily.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    productFamilyConfirmGenerateVariants: {
        id: 'productFamilyConfirmGenerateVariants',
        header: 'productFamily.confirm.generateVariants.title',
        body: ['productFamily.confirm.generateVariants.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'generateVariants', type: 'primary', action: 'generateVariants', text: 'productFamily.confirm.generateVariants.accept' }
        ]
    },
    productUpdate: {
        id: 'productUpdate',
        header: 'product.list.bulk.update.modal.title',
        form: {
            section: {
                id: 'productUpdateAttributesForm',
                meta: {
                    type: 'form',
                    // A partial update: only the fields touched here are written,
                    // and the rest are left alone on every selected product. The
                    // flag is what says so on screen.
                    dimUntouched: true,
                    width: '512px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'chooseWhatToUpdate',
                        label: 'product.list.bulk.update.info.label',
                        text: 'product.list.bulk.update.info.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'hconnect',
                        id: 'productGroup',
                        displayField: 'productGroup',
                        parentId: 'parentId',
                        label: 'product.form.attributes.productGroup',
                        placeholder: 'product.form.attributes.productGroup.placeholder',
                        modalTitle: "product.form.attributes.productGroup.modal.title",
                        entity: 'productGroup',
                        parentField: { field: 'type', value: 'normal' },
                        valueMap: {
                            'productGroup': 'id',
                        },
                        options: { withHeaders: true },
                        required: true,
                        defaultType: 'select',
                        linkedFields: ['productGroup']
                    },
                    {
                        type: 'connect',
                        id: 'supplierId',
                        displayField: 'supplierName',
                        label: 'product.form.attributes.supplier',
                        placeholder: 'product.form.attributes.supplier.placeholder',
                        modalTitle: 'product.form.attributes.supplier.modal.title',
                        entity: 'contact',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'contactType', value: 'supplier|both' }]
                        },
                        valueMap: {
                            'supplierId': 'id',
                            'supplierName': 'name'
                        },
                        options: { withHeaders: true }
                    },
                    {
                        type: 'select',
                        id: 'unitId',
                        displayField: 'unitName',
                        label: 'product.form.unitName',
                        placeholder: 'product.form.unitName.placeholder',
                        entity: 'unit',
                        valueMap: {
                            'unitName': 'name',
                            'unitId': 'id'
                        },
                        options: { withHeaders: true, autoSelectFirst: false },
                        required: true,
                        defaultType: 'none'
                    },
                    {
                        type: 'select',
                        id: 'taxId',
                        displayField: 'taxName',
                        label: 'product.form.vatTax',
                        placeholder: 'product.form.unitName.placeholder',
                        entity: 'vatTax',
                        valueMap: {
                            'taxName': 'name',
                            'taxId': 'id',
                            'taxRate': 'rate'
                        },
                        options: { withHeaders: false, autoSelectFirst: false },
                        required: true,
                        defaultType: 'none'
                    }
                ],
                buttons: [
                ],
            },
        },
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'update',
                type: 'primary',
                action: 'update',
                text: 'all.confirm.update.accept'
            }
        ]
    },
    projectConfirmCreateInvoice: {
        id: 'projectConfirmCreateInvoice',
        header: 'project.confirm.createInvoice.title',
        body: ['project.confirm.createInvoice.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'createInvoice',
                type: 'primary',
                action: 'createInvoice',
                actionType: 'goTo',
                text: 'project.confirm.createInvoice.accept',
                target: '/project/project/:id/createInvoice'
            }
        ]
    },
    projectConfirmDelete: {
        id: 'projectConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['project.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    projectTaskConfirmDelete: {
        id: 'projectTaskConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['project.task.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    purchaseOrderConfirmBook: {
        id: 'purchaseOrderConfirmBook',
        header: 'all.confirm.book.title',
        body: ['purchases.purchaseOrder.confirm.book.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'book', type: 'primary', action: 'book', text: 'all.confirm.book.accept' }
        ]
    },
    purchaseOrderConfirmConfirm: {
        id: 'purchaseOrderConfirmConfirm',
        header: 'purchases.purchaseOrder.confirm.confirm.title',
        body: ['purchases.purchaseOrder.confirm.confirm.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'confirm', type: 'primary', action: 'confirm', text: 'purchases.purchaseOrder.confirm.confirm.accept' }
        ]
    },
    purchaseOrderConfirmDelete: {
        id: 'purchaseOrderConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['purchases.purchaseOrder.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    purchaseRequestConfirmDelete: {
        id: 'purchaseRequestConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['purchases.purchaseRequest.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    purchaseRequestConfirmGeneratePOs: {
        id: 'purchaseRequestConfirmGeneratePOs',
        header: 'purchases.purchaseRequest.confirm.generatePOs.title',
        body: ['purchases.purchaseRequest.confirm.generatePOs.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'generatePurchaseOrders', type: 'primary', action: 'generatePurchaseOrders', text: 'purchases.purchaseRequest.confirm.generatePOs.accept' }
        ]
    },
    purchaseRequestConfirmSubmit: {
        id: 'purchaseRequestConfirmSubmit',
        header: 'purchases.purchaseRequest.confirm.submit.title',
        body: ['purchases.purchaseRequest.confirm.submit.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'submit', type: 'primary', action: 'submit', text: 'purchases.purchaseRequest.confirm.submit.accept' }
        ]
    },
    quoteConfirmBook: {
        id: 'quoteConfirmBook',
        header: 'all.confirm.book.title',
        body: ['quote.confirm.book.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'book', type: 'primary', action: 'book', text: 'all.confirm.book.accept' }
        ]
    },
    quoteConfirmCreateShipment: {
        id: 'quoteConfirmCreateShipment',
        header: 'quote.confirm.createShipment.title',
        body: ['quote.confirm.createShipment.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'createShipment',
                type: 'primary',
                action: 'createShipment',
                actionType: 'goTo',
                text: 'quote.confirm.createShipment.accept',
                target: '/sales/quote/newShipment/:id'
            }
        ]
    },
    quoteConfirmDelete: {
        id: 'quoteConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['quote.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    quoteConfirmInvoice: {
        id: 'quoteConfirmInvoice',
        header: 'all.confirm.invoice.title',
        body: ['quote.confirm.invoice.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            {
                id: 'invoice',
                type: 'primary',
                action: 'invoice',
                actionType: 'goTo',
                text: 'all.confirm.invoice.accept',
                target: '/sales/invoice/newFromQuote/:id'
            }
        ]
    },
    routingVersionConfirmActivate: {
        id: 'routingVersionConfirmActivate',
        header: 'routingVersion.confirm.activate.title',
        body: ['routingVersion.confirm.activate.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'activate', type: 'primary', action: 'activate', text: 'routingVersion.confirm.activate.accept' }
        ]
    },
    routingVersionConfirmDelete: {
        id: 'routingVersionConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['routingVersion.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    routingVersionConfirmRetire: {
        id: 'routingVersionConfirmRetire',
        header: 'routingVersion.confirm.retire.title',
        body: ['routingVersion.confirm.retire.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'retire', type: 'primary', action: 'retire', text: 'routingVersion.confirm.retire.accept' }
        ]
    },
    serviceContractConfirmDelete: {
        id: 'serviceContractConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.serviceContract.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    serviceLocationConfirmDelete: {
        id: 'serviceLocationConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.serviceLocation.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    serviceSkillConfirmDelete: {
        id: 'serviceSkillConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.serviceSkill.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    serviceTechnicianConfirmDelete: {
        id: 'serviceTechnicianConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.serviceTechnician.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    serviceTicketConfirmDelete: {
        id: 'serviceTicketConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.serviceTicket.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    serviceTypeConfirmDelete: {
        id: 'serviceTypeConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.serviceType.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    serviceWorkOrderConfirmDelete: {
        id: 'serviceWorkOrderConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['service.serviceWorkOrder.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    shiftConfirmDelete: {
        id: 'shiftConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['manufacturing.shift.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    userConfirmDelete: {
        id: 'userConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['user.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    warehouseOrderConfirmComplete: {
        id: 'warehouseOrderConfirmComplete',
        header: 'warehouseOrder.confirm.complete.title',
        body: ['warehouseOrder.confirm.complete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'complete', type: 'primary', action: 'complete', text: 'warehouseOrder.confirm.complete.accept' }
        ]
    },
    warehouseOrderConfirmRelease: {
        id: 'warehouseOrderConfirmRelease',
        header: 'warehouseOrder.confirm.release.title',
        body: ['warehouseOrder.confirm.release.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'release', type: 'primary', action: 'release', text: 'warehouseOrder.confirm.release.accept' }
        ]
    },
    warehouseOrderPreRelease: {
        id: 'warehouseOrderPreRelease',
        header: 'warehouseOrder.confirm.release.title',
        body: [],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'release', type: 'primary', action: 'release', text: 'warehouseOrder.confirm.release.accept' }
        ]
    },
    workCapabilityConfirmDelete: {
        id: 'workCapabilityConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['workCapability.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    workDepartmentConfirmDelete: {
        id: 'workDepartmentConfirmDelete',
        header: 'all.confirm.delete.title',
        body: ['manufacturing.workDepartment.confirm.delete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'delete', type: 'primary', action: 'delete', text: 'all.confirm.delete.accept' }
        ]
    },
    workOperationConfirmComplete: {
        id: 'workOperationConfirmComplete',
        header: 'workExecution.modal.complete.title',
        body: ['workExecution.modal.complete.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'complete', type: 'primary', action: 'complete', text: 'workExecution.modal.complete.accept' }
        ]
    },
    workOperationConfirmPause: {
        id: 'workOperationConfirmPause',
        header: 'workExecution.modal.pause.title',
        body: ['workExecution.modal.pause.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'pause', type: 'primary', action: 'pause', text: 'workExecution.modal.pause.accept' }
        ]
    },
    workOperationConfirmStop: {
        id: 'workOperationConfirmStop',
        header: 'workExecution.modal.stop.title',
        body: ['workExecution.modal.stop.body'],
        footer: [
            { id: 'dismiss', type: 'secondary', action: 'dismiss', text: 'all.confirm.cancel' },
            { id: 'stop', type: 'danger', action: 'stop', text: 'workExecution.modal.stop.accept' }
        ]
    },
}
